define.alias("ember-math-helpers/helpers/sin", "media/helpers/sin");